// @flow

import * as React from "react";
import { DefaultErrorPage } from "tabler-react";

type Props = {||};

const title = "Kinetic Platform"
const subtitle = "We're currently down for maintenance."
const details = "Thanks for your patience."

function MaintenancePage(props: Props): React.Node {
  return <DefaultErrorPage
    title={title}
    subtitle={subtitle}
    details={details}
  />
}

export default MaintenancePage;